<template>
  <div class="planListStyle">
    <div class="timeStyle">
      <span>请选择日期</span>
      <el-date-picker v-model="dateTopVALUE" @change="DateChange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
        type="date" placeholder="选择日期">
      </el-date-picker>
    </div>
    <div class="container">
      <div class="leftPlan">
        <div class="title">展会排程</div>
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in activities" :key="index" icon="el-icon-picture-outline-round"
            color="#0bbd87" :size="activity.size" @click.native="ItemClick(activity)">
            {{activity.startTime | startTimeilters}}&nbsp;
            <span v-if="activity.endTime">{{activity.endTime | endTimeilters}}</span>&nbsp;
            {{activity.subject}}&nbsp;
            <span v-if="activity.playType === 1">【直播】</span>
            <span v-else-if="activity.playType === 2">【录播】</span>
            <span v-else>【链接】</span>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="rightPlan">
        <el-button type="primary" @click.native="CreatActive">创建活动</el-button>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <div class="righttitle">活动信息</div>
          <el-form-item label="活动标题" prop="subject">
            <el-input v-model="ruleForm.subject"></el-input>
          </el-form-item>
          <el-form-item label="活动开始时间" prop="startTime">
            <el-time-picker v-model="ruleForm.startTime" format="HH:mm" value-format="HH:mm" placeholder="选择时间">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="活动结束时间">
            <el-time-picker v-model="ruleForm.endTime" format="HH:mm" value-format="HH:mm" placeholder="选择时间">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="请输入活动次序">
            <el-input v-model="ruleForm.sortPosition"></el-input>
          </el-form-item>
          <el-form-item label="活动简介">
            <el-input type="textarea" v-model="ruleForm.describes" placeholder="请输入直播简介" :rows="4"></el-input>
          </el-form-item>
          <div class="righttitle">活动类型</div>

          <el-form-item>
            <el-radio v-model="radio" @change="changeRadio" label="1">直播</el-radio>
            <el-select v-model="ruleForm.webinarId" :disabled="sectDisabled['0']" placeholder="请选择直播">
              <el-option v-for="(item, index) in selectChoseZhi" :key="item.webinarId" :label="item.subject"
                :value="item.webinarId"></el-option>
            </el-select>
            <el-button type="primary" v-if="EditADD" :disabled="sectDisabled['0']" @click="detailClick">设置</el-button>
          </el-form-item>

          <el-form-item>
            <el-radio v-model="radio" @change="changeRadio" label="2">录播视频</el-radio>
            <el-select v-model="ruleForm.webinarId" :disabled="sectDisabled[1]" placeholder="请选择录播视频活动资源">
              <el-option v-for="(item, index) in selectChoseLubo" :key="item.webinarId" :label="item.subject"
                :value="item.webinarId"></el-option>
            </el-select>
            <el-button type="primary" v-if="EditADD" :disabled="sectDisabled[1]" @click="detailClick">设置</el-button>
          </el-form-item>

          <el-form-item>
            <el-radio v-model="radio" @change="changeRadio" label="3">链接Url</el-radio>
            <el-input :disabled="sectDisabled[2]" v-model="ruleForm.linkUrl" placeholder="请输入链接的URL"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button ref="EditData" type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button v-if="EditDataDelete" type="danger" @click="DeleteClick()">删除</el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { netmettinglistAll, createActivity, activitylistOneDay, updateActivity, actiondelete } from '@/api/VhallLive'
  export default {
    name: 'PlanList',
    data() {
      return {
        dateTopVALUE: '',
        activities: [],
        ruleForm: {
          subject: '', // 活动标题
          startTime: '',// 活动开始时间
          endTime: '',// 活动结束时间
          describes: '',// 活动简介
          sortPosition: '',// 请输入活动次序
          linkUrl: '',// 选择是url链接的时候就是linkUrl
          webinarId: '',// 直播的id
          activityId: null // 活动的id
        },
        rules: {
          subject: [
            { required: true, message: '请输入活动名称', trigger: 'blur' }
          ],
          startTime: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ]
        },
        selectChoseZhi: [],// 直播的数据
        selectChoseLubo: [],// 直播的数据
        playType: 1, // 直播1，录播2, 链接url的判断
        radio: '1', // 单选框
        sectDisabled: {}, // 选择哪一个单选框，就展示哪一个下拉框 
        EditADD: false, // 判断是不是编辑
        EditDataNum: '',//每次点击的数据，为了删除
        EditDataDelete: false
      }
    },
    mounted() {
      // 直播录播的数据 直播录播的数据分开请求的原因是：点击编辑的时候异步请求不及时
      this.apiSendZhi()
      this.apiSendLubo()
      // 活动类型默认选择直播
      this.StartNOChose()
      // 排程默认选择今天
      this.dateTopVALUE = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      this.DateChange()
    },
    filters: {
      startTimeilters(value) {
        return value.split(" ")[1]
      },
      endTimeilters(value) {
        return value.split(" ")[1]
      }
    },
    methods: {
      // 排程数据
      DateChange() {
        // console.log(this.dateTopVALUE)
        var obj = {
          date: this.dateTopVALUE
        }
        activitylistOneDay(obj).then(response => {
          if (response.data) {
            // console.log(response.data)
            this.activities = response.data
          }
        })
      },
      // 点击排程数据进行编辑
      ItemClick(item) {
        // console.log(item)
        this.EditDataNum = item
        this.$refs.EditData.$el.innerText = '保存'
        this.EditDataDelete = true
        this.EditADD = true
        this.ruleForm.subject = item.subject
        this.ruleForm.startTime = item.startTime
        this.ruleForm.sortPosition = item.sortPosition
        this.ruleForm.describes = item.describes
        this.ruleForm.activityId = item.activityId
        this.dateTopVALUE = item.startTime.split(' ')[0]
        this.ruleForm.startTime = item.startTime.split(' ')[1]
        if (item.endTime) {
          this.ruleForm.endTime = item.endTime.split(' ')[1]
        }
        this.NOChose()
        if (item.playType === 1) {
          this.radio = '1'
          this.sectDisabled[0] = false
          this.playType = 1
          this.apiSendZhi()
          for (var i = 0; i < this.selectChoseZhi.length; i++) {
            if (item.webinarId === this.selectChoseZhi[i].webinarId) {
              this.ruleForm.webinarId = this.selectChoseZhi[i].subject
            }
          }
        } else if (item.playType === 2) {
          this.radio = '2'
          this.sectDisabled[1] = false
          this.playType = 2
          this.apiSendLubo()
          for (var i = 0; i < this.selectChoseLubo.length; i++) {
            if (item.webinarId === this.selectChoseLubo[i].webinarId) {
              this.ruleForm.webinarId = this.selectChoseLubo[i].subject
            }
          }
        } else {
          this.radio = '3'
          this.playType = 3
          this.sectDisabled[2] = false
          this.ruleForm.linkUrl = item.linkUrl
        }
      },
      // 设置-跳到详情页
      detailClick() {
        for (var i = 0; i < this.selectChoseZhi.length; i++) {
          if (this.selectChoseZhi[i].subject === this.ruleForm.webinarId) {
            this.ruleForm.webinarId = this.selectChoseZhi[i].webinarId
          }
        }
        // console.log(this.ruleForm.webinarId)
        this.$router.push({ name: 'LiveDetail', params: { item: this.ruleForm } })
      },
      // 开始的时候默认选择直播
      StartNOChose() {
        for (var i = 0; i < 3; i++) {
          this.$set(this.sectDisabled, i, true)
          this.$set(this.sectDisabled, 0, false)
        }
      },
      // 默认设置所有的活动类型不可选
      NOChose() {
        for (var i = 0; i < 3; i++) {
          this.$set(this.sectDisabled, i, true)
        }
      },
      // 单选框事件更换数据
      changeRadio(label) {
        this.NOChose()
        this.ruleForm.webinarId = ''
        this.ruleForm.linkUrl = ''
        if (label === '1') { // 直播
          this.playType = 1
          this.apiSendZhi()
          this.sectDisabled[0] = false
        } else if (label === '2') {
          this.playType = 2 // 录播
          this.apiSendLubo()
          this.sectDisabled[1] = false
        } else {
          this.playType = 3 // 外链url
          this.sectDisabled[2] = false
        }
      },
      // 直播的数据
      apiSendZhi() {
        var obj = {
          playType: 1
        }
        netmettinglistAll(obj).then(response => {
          if (response.data) {
            // console.log(response.data)
            this.selectChoseZhi = response.data
          }
        })
      },
      // 录播的数据
      apiSendLubo() {
        var obj = {
          playType: 2
        }
        netmettinglistAll(obj).then(response => {
          if (response.data) {
            // console.log(response.data)
            this.selectChoseLubo = response.data
          }
        })
      },
      // 创建
      submitForm(formName) {
        // console.log(this.dateTopVALUE)
        // console.log(this.ruleForm)
        this.EditDataDelete = true
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.ruleForm.startTime = this.dateTopVALUE + ' ' + this.ruleForm.startTime
            this.ruleForm.endTime = this.dateTopVALUE + ' ' + this.ruleForm.endTime
            // 编辑转换
            if (this.EditADD) {
              if (this.playType === 1) {
                var VarDate = this.selectChoseZhi
              } else {
                var VarDate = this.selectChoseLubo
              }
              for (var i = 0; i < VarDate.length; i++) {
                if (VarDate[i].subject === this.ruleForm.webinarId) {
                  this.ruleForm.webinarId = VarDate[i].webinarId
                }
              }
            }
            if (this.playType === 1 && !this.ruleForm.webinarId) {
              this.$message({
                message: '请选择直播',
                type: 'warning'
              })
            }
            else if (this.playType === 2 && !this.ruleForm.webinarId) {
              this.$message({
                message: '请选择录播',
                type: 'warning'
              })
            }
            else if (this.playType === 3 && !this.ruleForm.linkUrl) {
              this.$message({
                message: '请添加链接url',
                type: 'warning'
              })
            } else {
              var obj = {
                subject: this.ruleForm.subject,
                startTime: this.ruleForm.startTime,
                endTime: this.ruleForm.endTime,
                sortPosition: this.ruleForm.sortPosition,
                activityId: this.ruleForm.activityId,
                webinarId: this.ruleForm.webinarId,
                describes: this.ruleForm.describes,
                linkUrl: this.ruleForm.linkUrl,
                playType: this.playType
              }
            //   console.log(obj)
              // 编辑页面
              if (this.EditADD) {
                updateActivity(obj).then(response => {
                  this.$message({
                    message: response.msg,
                    type: 'success'
                  })
                  this.DateChange()
                })
                // 创建页面
              } else {
                // console.log(this.playType)
                createActivity(obj).then(response => {
                //   console.log(response)
                  this.$message({
                    message: '活动创建成功',
                    type: 'success'
                  })
                  this.DateChange()
                })
              }
              this.dateTopVALUE = this.ruleForm.startTime.split(' ')[0]
              this.ruleForm.startTime = this.ruleForm.startTime.split(' ')[1]
              this.ruleForm.endTime = this.ruleForm.endTime.split(' ')[1]
            }
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      },
      // 点击创建
      CreatActive() {
        this.EditADD = false
        this.ruleForm.subject = ''
        this.ruleForm.startTime = ''
        this.ruleForm.endTime = ''
        this.ruleForm.describes = ''
        this.ruleForm.sortPosition = ''
        this.ruleForm.linkUrl = ''
        this.ruleForm.webinarId = ''
        this.ruleForm.activityId = ''
      },
      // 删除活动
      DeleteClick() {
        // console.log(this.EditDataNum)
        var obj = {
          activityId: this.EditDataNum.activityId
        }
        actiondelete(obj).then(response => {
          if (response.data) {
            // console.log(response.data)
            this.DateChange()
            this.CreatActive()
            this.$message({
              message: response.msg,
              type: 'success'
            })
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .planListStyle {
    width: 100%;
  }

  .timeStyle {
    margin-left: 40%;
    margin-top: 30px;
  }

  .container {
    width: 1000px;
    margin-left: calc(50% - 500px);
    font-size: 0px;
    padding-top: 30px;
  }

  .title {
    height: 60px;
    font-size: 18px;
    line-height: 60px;
    margin-left: 15px;
  }

  /* 左边 */
  .leftPlan {
    width: 350px;
    height: 600px;
    display: inline-block;
    vertical-align: top;
    border-right: 1px solid #cdcdcd;
  }

  .el-timeline {
    margin-top: 20px;
  }


  /* 右边 */
  .rightPlan {
    width: 600px;
    height: 600px;
    display: inline-block;
  }

  .righttitle {
    margin-left: 20px;
    height: 60px;
    font-size: 16px;
    line-height: 60px;
  }

  .rightPlan>>>.el-input {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Live-Platform/Plan-List.vue